<div class="appointment-date-widget__header" data-test-id="appointment-date-widget-month">{{ date | date : 'MMM' }}</div>
<div class="appointment-date-widget__body">
  <span data-test-id="appointment-date-widget-day" class="text-[30px] leading-[30px] font-bold">{{ date | date : 'd' }}</span>
  <span data-test-id="appointment-date-widget-time" class="text-[12px] font-bold">{{ date | date : 'HH:mm' }}</span>
</div>
